<template>
  <section class="about-us">
    <header class="sec-titr"><h2 class="sec-titr__title">درباره ما</h2></header>
    <main>
      <div class="introduce">
        <div
          class="introduce-image-box1 introduce-image-box"
          ref="boxImage1"
          :class="{ active: showBoxImage1 }"
        >
          <div
            class="introduce-image-box1__images introduce-image-box__images"
            ref="boxImageChilde1"
          >
            <img src="../../../public/image/about-us.jpg" alt="aboutUs" />
            <img src="../../../public/image/hexagon-mask.png" alt="aboutUs" />
            <img src="../../../public/image/hexagon-mask.png" alt="aboutUs" />
            <img src="../../../public/image/hexagon-mask.png" alt="aboutUs" />
          </div>
        </div>
        <div
          class="introduce-text-box1 introduce-text-box"
          ref="boxText1"
          :class="{ active: showBoxText1 }"
        >
          <div class="introduce-text-box1__text introduce-text-box__text">
            <h3>
              معرفی نیش و نوش
            </h3>
            <p>
              فروشگاه اینترنتی نیش و نوش در سال ۱۳۹۵ برای ارائه محصولات طبیعی
              زنبور عسل راه اندازی گردید و همواره در تلاش است بهترین محصول موجود
              را با حذف واسطه ها و سود کم به صورت مستقیم از کندو به مصرف کننده
              برساند که این کار باعث حفظ کیفیت و کسب رضایت هر چه بیشتر عزیزان
              گردیده است.این مجموعه با ۱۵ سال تجربه زنبورداری، به دنبال نامی
              زیبنده برای برند خود بعد از صدها پیشنهاد و ماه ها بررسی، کلمه نیش
              و نوش که تداعی کننده آهوهای خراسان شمالی می شد انتخاب گردید که این
              نام نشانگر رابطه عمیق محصولات این مجموعه با طبیعت و تمرکز بر طبیعی
              بودن، ارگانیک و تعلق داشتن به طبیعت می باشد.
            </p>
          </div>
        </div>
        <div
          class="introduce-image-box2 introduce-image-box"
          ref="boxImage2"
          :class="{ active: showBoxImage2 }"
        >
          <div
            class="introduce-image-box2__images introduce-image-box__images"
            ref="boxImageChilde2"
          >
            <img src="../../../public/image/header3.jpg" alt="aboutUs" />
            <img src="../../../public/image/hexagon-mask.png" alt="aboutUs" />
            <img src="../../../public/image/hexagon-mask.png" alt="aboutUs" />
          </div>
        </div>
        <div
          class="introduce-text-box2 introduce-text-box"
          :class="{ active: showBoxText2 }"
          ref="boxText2"
        >
          <div class="introduce-text-box2__text introduce-text-box__text">
            <h3>مطمئن خرید کنید<span>!</span></h3>
            <p>
              مجموعه نیش و نوش به تعهداتش در ارائه بهترین خدمات و محصولات پایبند
              می باشد و امیدمان آن است که سال های سال افتخار خدمت رسانی به شما
              را داشته باشیم. اطمینان شما دلگرمی ماست. ما که برای محصولی طبیعی و
              خالص خود را ملزم می دانیم که بهترین باشیم و در پرتوی این اندیشه
              برترین ها را برای شما فراهم کنیم تلاشمان این است که بهترین و مرغوب
              ترین محصولات زنبور عسل را با ضمانت نامه، برگه آزمایش و قیمت مناسب
              به فروش برسانیم که این امر باعث کسب رضایت هر چه بیشتر مشتریان عزیز
              گردیده است. ما یک مجموعه زنبورداری هستیم که دارای مجوز زنبورداری
              از وزارت جهاد کشاورزی، اینماد از وزارت صنعت، معدن و تجارت، مجوز
              ساماندهی از وزارت فرهنگ و ارشاد اسلامی می باشیم. همچنین سایت نیش و
              نوش طبق رتبه بندی alexa بزرگترین و پربازدید ترین سایت در حوزه فروش
              محصولات زنبور عسل در ایران می باشد.
            </p>
          </div>
        </div>
      </div>
      <div
        class="introduce-garanty"
        :class="{ active: showBoxText3 }"
        ref="boxText3"
      >
        <div class="introduce-garanty__text">
          <h3>
            ضمانت نامه کامل
          </h3>
          <p>
            تمام محصولات مجموعه آهوتا دارای برگه آزمایش معتبر می باشند. برای
            اطمینان بیشتر خوشحال خواهیم شد خود مشتری نیز محصولات را به آزمایشگاه
            تخصصی عسل ببرد و اگر ثابت شد که محصول طبیعی نیست، ما به صورت رسمی
            همراه با مهر و امضا تضمین خواهیم کرد که بدون چون و چرا ۲ برابر مبلغ
            سفارش به علاوه هزینه آزمایش را حداکثر تا ۲۴ ساعت به حساب مشتری واریز
            کنیم. همچنین ما مطمئنیم که سود واقعی در خرید های دائم است نه فروش
            یکباره. به همین دلیل بهترین محصولات طبیعی را برای مشتریان ارسال می
            کنیم تا همواره از ما رضایت داشته و این همکاری ادامه دار باشد ضمن
            اینکه اعتقاد داریم مهمتر از تمام آزمایشات و تضمین های ریالی صداقت و
            اعتماد زنبوردار است که ارزش دارد.
          </p>
        </div>
      </div>
    </main>
    <footer class="gallery">
      <div class="gallery-box">
        <div class="gallery-box-item-1 gallery-box-item">
          <img
            class="gallery-box-item__image-1 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-1.jpg"
            alt="gallery"
          />
        </div>
        <div class="gallery-box-item-2 gallery-box-item">
          <img
            class="gallery-box-item__image-2 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-2.jpg"
            alt="gallery"
          />
        </div>
        <div class="gallery-box-item-3 gallery-box-item">
          <img
            class="gallery-box-item__image-3 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-3.jpg"
            alt="gallery"
          />
        </div>
        <div class="gallery-box-item-4 gallery-box-item">
          <img
            class="gallery-box-item__image-4 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-4.jpg"
            alt="gallery"
          />
        </div>
        <div class="gallery-box-item-5 gallery-box-item">
          <img
            class="gallery-box-item__image-5 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-5.jpg"
            alt="gallery"
          />
        </div>
        <div class="gallery-box-item-6 gallery-box-item">
          <img
            class="gallery-box-item__image-6 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-6.jpg"
            alt="gallery"
          />
        </div>
        <div class="gallery-box-item-7 gallery-box-item">
          <img
            class="gallery-box-item__image-7 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-7.jpg"
            alt="gallery"
          />
        </div>
        <div class="gallery-box-item-8 gallery-box-item">
          <img
            class="gallery-box-item__image-8 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-8.jpg"
            alt="gallery"
          />
        </div>
        <div class="gallery-box-item-9 gallery-box-item">
          <img
            class="gallery-box-item__image-9 gallery-box-item__image"
            src="../../../public/image/gallery/gallery-9.jpg"
            alt="gallery"
          />
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
export default {
  data() {
    return {
      showBoxText1: false,
      showBoxText2: false,
      showBoxText3: false,
      showBoxImage1: false,
      showBoxImage2: false,
      boxImage1: null,
      boxImageChilde1: null,
      boxImageChilde2: null,
      boxImage2: null,
      boxText1: null,
      boxText2: null,
      boxText3: null,
      vh: (window.innerHeight * 3) / 5,
      vhBottom: (window.innerHeight * 2.5) / 5,
    };
  },
  methods: {
    showBox() {
      let heightOfBoxImage = getComputedStyle(this.boxImage1).getPropertyValue(
        "height"
      );
      let halfHeightBoxImage = (heightOfBoxImage.slice(0, -2) * 1.3) / 2;
      let topOfBoxImage1 = this.boxImage1.getBoundingClientRect().top;
      let topOfBoxImage2 = this.boxImage2.getBoundingClientRect().top;
      let bottomOfBoxImage1 = this.boxImage1.getBoundingClientRect().bottom;
      let bottomOfBoxImage2 = this.boxImage2.getBoundingClientRect().bottom;
      let topOfBoxText1 = this.boxText1.getBoundingClientRect().top;
      let topOfBoxText2 = this.boxText2.getBoundingClientRect().top;
      let topOfBoxText3 = this.boxText3.getBoundingClientRect().top;

      if (bottomOfBoxImage1 < halfHeightBoxImage) {
        this.boxImageChilde1.style.transform = "translateY(-30%)";
      } else {
        this.boxImageChilde1.style.transform = "translateY(0%)";
      }

      if (bottomOfBoxImage2 < halfHeightBoxImage) {
        this.boxImageChilde2.style.transform = "translateY(-30%)";
      } else {
        this.boxImageChilde2.style.transform = "translateY(0%)";
      }

      if (topOfBoxImage1 < this.vh) {
        this.showBoxImage1 = true;
      }
      if (topOfBoxImage2 < this.vh) {
        this.showBoxImage2 = true;
      }
      if (topOfBoxText1 < this.vh) {
        this.showBoxText1 = true;
      }
      if (topOfBoxText2 < this.vh) {
        this.showBoxText2 = true;
      }
      if (topOfBoxText3 < this.vh) {
        this.showBoxText3 = true;
      }
    },
  },
  mounted() {
    this.boxImage1 = this.$refs.boxImage1;
    this.boxImageChilde1 = this.$refs.boxImageChilde1;
    this.boxImageChilde2 = this.$refs.boxImageChilde2;
    this.boxImage2 = this.$refs.boxImage2;
    this.boxText1 = this.$refs.boxText1;
    this.boxText2 = this.$refs.boxText2;
    this.boxText3 = this.$refs.boxText3;
    this.showBox();

    window.addEventListener("scroll", () => {
      this.showBox();
    });
  },
};
</script>

<style></style>
